export enum DisplayMode {
  TemplatePicker,
  IssueCreation,
}

type getDefaultDisplayModeParams = {
  repositoryHasIssuesEnabled: boolean
  hasSelectedTemplate: boolean
  hasAvailableTemplates: boolean
}

export function getDefaultDisplayMode({
  repositoryHasIssuesEnabled,
  hasSelectedTemplate,
  hasAvailableTemplates,
}: getDefaultDisplayModeParams) {
  if (!repositoryHasIssuesEnabled) {
    // Template picker will show an error message for repositories without issues, therefore show this.
    return DisplayMode.TemplatePicker
  }

  // If we have a selected template or no available templates, we should go straight to issue creation.
  if (hasSelectedTemplate || !hasAvailableTemplates) {
    return DisplayMode.IssueCreation
  }

  return DisplayMode.TemplatePicker
}
